<template>
  <InformeDetailView fetch-path="informe-auditoria" toolbar-title="Informes" type-label="Tipo de Informe"
               descripion-label="Observación"></InformeDetailView>
</template>

<script>
import InformeDetailView from '../components/InformeAuditoriaDetailView.vue'

export default {
  components: {
    InformeDetailView
  }
}
</script>
